import { useState } from "react";
import PhoneInputSimple from "react-phone-number-input/input";
import { PhoneInput } from "react-international-phone";
import Autocomplete from "react-google-autocomplete";
import "react-international-phone/style.css";
const PLACES_KEY = process.env.REACT_APP_PLACES_KEY;

function PhoneFieldWrapper({ obj }) {
  const [isInternational, setIsInternational] = useState(false);

  return (
    <>
      <button
        type="button"
        className="phone-intl-toggle"
        onClick={() => setIsInternational((p) => !p)}
      >
        {isInternational ? "← Domestic" : "International number?"}
      </button>

      {isInternational ? (
        <div
          className={`reserve-select input-phone phone-wrapper phone-intl ${
            obj.error ? "reserve-select-error" : ""
          }`}
          onClick={(e) => {
            const input = e.currentTarget.querySelector("input");
            if (input) input.focus();
          }}
        >
          <PhoneInput
            defaultCountry="us"
            placeholder=""
            value={obj.value || ""}
            onChange={(value) => obj.handleChange(value)}
            onFocus={obj.onFocus}
            onBlur={obj.onBlur}
          />
        </div>
      ) : (
        <PhoneInputSimple
          country="US"
          className={`reserve-select ${obj.error ? "reserve-select-error" : ""}`}
          placeholder=""
          value={obj.value || ""}
          onChange={(value) => obj.handleChange(value ?? "")}
          onFocus={obj.onFocus}
          onBlur={obj.onBlur}
        />
      )}
    </>
  );
}

function Input(obj) {
  function addressBody(obj) {
    return (
      <Autocomplete
        apiKey={PLACES_KEY}
        type="text"
        id="address"
        placeholder=""
        value={obj.value}
        className={`reserve-select ${obj.error ? "reserve-select-error" : ""}`}
        onChange={(event) => obj.handleChange(event)}
        onPlaceSelected={(place) => obj.handlePlaceSelect(place)}
        options={{
          location: { lat: 42.0451, lng: -87.6877 },
          radius: 100,
          types: ["address"],
        }}
      />
    );
  }

  function textBody(obj) {
    return (
      <input
        type="text"
        id={obj.id}
        className={`reserve-select select-${obj.name} ${
          obj.error && `reserve-select-error`
        }`}
        onChange={(event) => obj.handleChange(event)}
        placeholder={obj.name === "other" ? obj.value : undefined}
      ></input>
    );
  }

  function textAreaBody(obj) {
    return (
      <textarea
        type="text"
        maxlength="500"
        id={obj.id}
        className={`reserve-select tai ${obj.error && `reserve-select-error`}`}
        onChange={(event) => obj.handleChange(event)}
      ></textarea>
    );
  }

  function inputBody(obj) {
    switch (obj.type) {
      case "phone":
        return <PhoneFieldWrapper obj={obj} />;
      case "textarea":
        return textAreaBody(obj);
      case "address":
        return addressBody(obj);
      default:
        return textBody(obj);
    }
  }

  return (
    <div
      className={`input-${obj.name} ${
        obj.hidden && "input-hidden"
      } input-group`}
    >
      <label className={`input-text ${obj.error && `input-text-error`}`}>
        {" "}
        {obj.text}{" "}
      </label>
      {inputBody(obj)}
    </div>
  );
}

export default Input;
